__turbopack_context__.v({
  "bottomBarContainer": "witeGG_bottomBarContainer",
  "cartItemCount": "witeGG_cartItemCount",
  "cartTotal": "witeGG_cartTotal",
  "desktopLeftPanel": "witeGG_desktopLeftPanel",
  "desktopMidPanel": "witeGG_desktopMidPanel",
  "desktopRightPanel": "witeGG_desktopRightPanel",
  "itemInfo": "witeGG_itemInfo",
  "midPanelPhone": "witeGG_midPanelPhone",
  "mobileTopRow": "witeGG_mobileTopRow",
  "priceDetailsContainer": "witeGG_priceDetailsContainer",
  "priceInfoContainer": "witeGG_priceInfoContainer",
  "shopBottomBarSlideUp": "witeGG_shopBottomBarSlideUp",
});
